// NFL playoff weeks covered in this draft format (Weeks 15, 16, 17)
export const WEEK_NUMS = [15, 16, 17];

// Season Wrapped unlock — kickoff of the first NFL game (the moment the summer
// drafting season ends). Before this instant the Wrapped shows a countdown; at/
// after it, the story unlocks. 2026 first game: Sun Sep 6, 6:20 PM MT (MDT,
// UTC−6) → 00:20 UTC on Sep 7.
export const SEASON_KICKOFF = "2026-09-07T00:20:00Z";

/** True once the season has kicked off (Wrapped unlocked). */
export function isWrappedUnlocked(now: Date = new Date()): boolean {
  return now.getTime() >= new Date(SEASON_KICKOFF).getTime();
}

// ADP freeze. Underdog stopped taking drafts after 2026-09-10: BBM, Eliminator
// and Weekly ADP are all byte-identical from that morning's scrape onward. The
// daily scrape and sync are switched off for the season (see
// .github/workflows/sync-adp.yml) and the published data is pinned to that
// final board.
//
// Note this is NOT the same instant as SEASON_KICKOFF above (Sun Sep 6) —
// Underdog kept drafts open past the opener, into the main week 1 slate. Don't
// "fix" one to match the other; they measure different things.
//
// This is the date of that snapshot, and it is what tells the UI to present a
// stale "last updated" as final rather than as a stalled pipeline. Set it back
// to null when the 2027 scrape is re-enabled.
export const ADP_FROZEN_AT: string | null = "2026-09-10";

// Boundary between pre-NFL-draft and regular-season (post-draft) tournaments.
// Drafts dated BEFORE this date are Pre-Draft; on/after are Regular Season.
// 2026: Underdog's pre-draft tournaments closed Apr 26 and regular-season
// tournaments opened Apr 27, so the cutoff is Apr 27. Update once per year.
export const NFL_DRAFT_CUTOFF = "2026-04-27";

// Matchup schedule for each team across the three playoff weeks.
// Format: "@OPP" = away, "vsOPP" = home
// 2025 data — kept for reference. The live schedule is fetched at runtime from:
// https://raw.githubusercontent.com/rosterOS/rosterOS-data/main/schedule.json
// Shape: { "weekNums": [15,16,17], "weekSchedules": { "ARI": ["@OPP", ...], ... } }
export const WEEK_SCHEDULES = {
  ARI: ["@HOU", "vsATL", "@CIN"],
  ATL: ["@TB", "@ARI", "vsLAR"],
  BAL: ["@CIN", "vsNE", "@GB"],
  BUF: ["@NE", "@CLE", "vsPHI"],
  CAR: ["@NO", "vsTB", "vsSEA"],
  CHI: ["vsCLE", "vsGB", "@SF"],
  CIN: ["vsBAL", "@MIA", "vsARI"],
  CLE: ["@CHI", "vsBUF", "vsPIT"],
  DAL: ["vsMIN", "vsLAC", "@WAS"],
  DEN: ["vsGB", "vsJAX", "@KC"],
  DET: ["@LAR", "vsPIT", "@MIN"],
  GB: ["@DEN", "@CHI", "vsBAL"],
  HOU: ["vsARI", "vsLV", "@LAC"],
  IND: ["@SEA", "vsSF", "vsJAX"],
  JAX: ["vsNYJ", "@DEN", "@IND"],
  KC: ["vsLAC", "@TEN", "vsDEN"],
  LAC: ["@KC", "@DAL", "vsHOU"],
  LAR: ["vsDET", "@SEA", "@ATL"],
  LV: ["@PHI", "@HOU", "vsNYG"],
  MIA: ["@PIT", "vsCIN", "vsTB"],
  MIN: ["@DAL", "@NYG", "vsDET"],
  NE: ["vsBUF", "@BAL", "@NYJ"],
  NO: ["vsCAR", "vsNYJ", "@TEN"],
  NYG: ["vsWAS", "vsMIN", "@LV"],
  NYJ: ["@JAX", "@NO", "vsNE"],
  PHI: ["vsLV", "@WAS", "@BUF"],
  PIT: ["vsMIA", "@DET", "@CLE"],
  SEA: ["vsIND", "vsLAR", "@CAR"],
  SF: ["vsTEN", "@IND", "vsCHI"],
  TB: ["vsATL", "@CAR", "@MIA"],
  TEN: ["@SF", "vsKC", "vsNO"],
  WAS: ["@NYG", "vsPHI", "vsDAL"],
};
